import { ServiceId, ServiceSlug } from '@ply-io/ply-front-shared-utilities';
import {
	usePlacementsActions,
	usePlacementsGetters,
	useContextsActions,
	useContextsGetters,
	useAppsActions,
	useAppsGetters,
} from '@/store-composables';
import { computed } from 'vue';

const fetchService = async (serviceId: ServiceId) => {
	const { getServiceData } = useAppsActions();
	const { getContextsOfService } = useContextsActions();
	const { getPlacementsOfService } = usePlacementsActions();
	return await Promise.all([getServiceData(serviceId), getContextsOfService(serviceId), getPlacementsOfService(serviceId)]);
};

const fetchServiceBySlug = async (slug: ServiceSlug) => {
	const { getServiceDataBySlug } = useAppsActions();
	const { getContextsOfServiceBySlug } = useContextsActions();
	const { getPlacementsOfServiceBySlug } = usePlacementsActions();
	return await Promise.all([getServiceDataBySlug(slug), getContextsOfServiceBySlug(slug), getPlacementsOfServiceBySlug(slug)]);
};

const fetchServices = async (services: ServiceId[]) => {
	await Promise.all(services.map(fetchService));
};
const fetchServicesBySlug = async (slugs: ServiceSlug[]) => {
	await Promise.all(slugs.map(fetchServiceBySlug));
};
const fetchAllServices: () => Promise<void> = async () => {
	const { getAvailableApps } = useAppsActions();
	await getAvailableApps();
};

export function useServices() {
	const { getAllServicesList, getService, getServiceBySlug } = useAppsGetters();
	const { getServicePlacements } = usePlacementsGetters();
	const { getServiceContexts } = useContextsGetters();
	return {
		fetchService: async (serviceId: ServiceId) => {
			const { getServiceData } = useAppsActions();
			const { getContextsOfService } = useContextsActions();
			const { getPlacementsOfService } = usePlacementsActions();
			return await Promise.all([getServiceData(serviceId), getContextsOfService(serviceId), getPlacementsOfService(serviceId)]);
		},
		fetchServiceBySlug,
		fetchServices,
		fetchServicesBySlug,
		fetchAllServices,
		getService,
		getServiceBySlug,
		allServices: getAllServicesList,
		getPlacements: computed(() => (serviceId: ServiceId) => getServicePlacements.value(serviceId)),
		getContexts: getServiceContexts,
	};
}
